<template>
	<div class="p-1">
		<b-row class="mb-1">
			<b-col>
				<h1 class="font-weight-bolder">Tabla Detallada</h1>
				<div>Información completa de hijos e incidencias</div>
			</b-col>
		</b-row>
		<b-row class="mb-1">
			<b-col class="d-flex gap-x-2">
				<b-button
					@click="changeLimit(10)"
					:variant="limit == 10 ? 'primary' : 'outline-primary'"
					:active="limit == 10"
				>
					Top 10
				</b-button>
				<b-button
					@click="changeLimit(null)"
					:variant="limit == null ? 'primary' : 'outline-primary'"
					:active="limit == null"
				>
					Ver Todos
				</b-button>
			</b-col>
			<b-col class="d-flex justify-content-end align-items-center">
				<b-input-group id="cintillo-ala-input-group">
					<b-form-input
						v-model="search"
						class="d-inline-block"
						placeholder="Buscar ejemplar"
						@keyup.enter="handleInputSearch"
						debounce="500"
					/>
					<b-input-group-append>
						<b-button variant="outline-primary" @click="handleInputSearch()">
							<feather-icon class="cursor-pointer" icon="SearchIcon" />
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
		</b-row>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="35vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								{{ index + 1 }}
							</b-td>
							<b-td class="text-center">
								<div class="font-weight-bolder">
									{{ `${row.plate} ${row.alias ? "/" : ""} ${row.alias ? row.alias : ""}` }}
								</div>
							</b-td>
							<b-td class="text-center">
								<b-button @click="openDetail(row)" variant="flat-info">
									{{ row.incidence_qty }}
								</b-button>
							</b-td>
							<b-td class="text-center">
								<b-button @click="openDetail(row)" variant="flat-info">
									{{ row.son_qty }}
								</b-button>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<TopSonIncidenceDetails
			v-if="showDetail.show"
			:category_id="category_id"
			:specimen="showDetail.info"
			@close="showDetail.show = false"
		/>
	</div>
</template>

<script>
import SpecimenService from "@/services/specimens.service.js"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
import TopSonIncidenceDetails from "@/views/amg/specimens/components/mainDashboard/top-son-incidences/components/TopSonIncidenceDetails.vue"
export default {
	name: "TopSonIncidencesTableDetails",
	props: {
		category_id: {
			required: true,
		},
	},
	components: {
		SpecimenIncidencesModal,
		TopSonIncidenceDetails,
	},
	data: () => ({
		isLoading: false,
		rows: [],
		limit: 10,
		search: "",
		incidenceModal: {
			show: false,
			info: null,
		},
		showDetail: {
			show: false,
			info: null,
		},
	}),
	computed: {
		fields() {
			return [
				{ key: "index", label: "#", class: "text-center" },
				{ key: "parent", label: `${this.category_id == 1 ? "Padrillo" : "Madrilla"}`, class: "text-center" },
				{ key: "incidences", label: "Incidencias", class: "text-center" },
				{ key: "sons", label: "Hijos", class: "text-center" },
			]
		},
	},
	methods: {
		handleInputSearch() {
			this.getRows()
		},
		openDetail(row) {
			this.showDetail.info = row
			this.showDetail.show = true
		},
		changeLimit(newLimit) {
			if (this.limit === newLimit) return
			this.limit = newLimit
			this.getRows()
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await SpecimenService.getTopSonIncidencesReport({
					category_id: this.category_id,
					limit: this.limit,
					search: this.search,
				})
				this.rows = data || []
			} catch (error) {
				console.error("Error fetching rows in TopSonIncidenceDetails:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.getRows()
	},
}
</script>
<style lang="scss" scoped>
.incidences-counter {
	position: absolute;
	top: -1rem;
	left: 6rem;
	height: 1.2rem;
	max-width: 1.2rem;
	color: #fff;
	display: flex !important;
	align-items: center;
	justify-content: center;
	padding: 2px;
	background: var(--primary);
	border-radius: 0.2rem;
	font-weight: bolder;
	font-size: 12px;
}
.icon-disabled {
	pointer-events: none;
	opacity: 0.5;
}
</style>
